import { ButtonHTMLAttributes } from 'react'
import { useLanguage } from '@/hooks/useLanguage'
import { t } from '@/utils/i18n'
import { IconArrowLeft } from '@/components/icons/Icons'
import './BackButton.css'

interface BackButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** 뒤로가기 버튼 텍스트 (기본값: 번역된 "뒤로") */
  children?: string
  /** 커스텀 클릭 핸들러 */
  onClick?: () => void
}

/**
 * 뒤로가기 버튼 공통 컴포넌트
 * 일관된 스타일과 동작을 제공하는 뒤로가기 버튼
 */
function BackButton({
  children,
  onClick,
  className = '',
  ...props
}: BackButtonProps) {
  const { language } = useLanguage()
  const buttonText = children || t('common.back', language)

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      window.history.back()
    }
  }

  return (
    <button
      className={`back-button ${className}`}
      onClick={handleClick}
      {...props}
    >
      <IconArrowLeft size={18} className="back-button__icon" />
      {buttonText}
    </button>
  )
}

export default BackButton

